import { Construction } from 'lucide-react';
import { Surface } from '@agenda-facil/ui';
import { AdminPageHeader } from './admin-page-header';

export function AdminPendingPage({ title, description }: { title: string; description: string }) {
  return (
    <div>
      <AdminPageHeader title={title} description={description} />
      <Surface className="mt-7 grid min-h-72 place-items-center px-6 text-center">
        <div className="max-w-md">
          <span className="mx-auto grid size-12 place-items-center rounded-xl bg-[var(--warning-soft)] text-[var(--warning)]">
            <Construction size={22} />
          </span>
          <h2 className="mt-5 font-black">Próximo corte da administração</h2>
          <p className="mt-2 text-sm leading-6 text-[var(--muted-foreground)]">
            Esta área ainda não executa operações. Ela será conectada ao backend antes de receber
            ações ou dados simulados.
          </p>
        </div>
      </Surface>
    </div>
  );
}
